import { Job } from '../../modules/job/models';
import { HistoricalQueueStatus } from '../../modules/job/models/historical-queue-dto.model';
import { StatusType } from '../enums';

export interface NotificationModel {
	message: string;
	messageDate: Date;
	status: StatusType;
	id?: number; // Currently this is the HistoricalQueueId, but if notifications expand, we need a better way to identify this
	fromJob?: Job;
	toJob?: Job;
	timePassed?: string;
	route?: string;
	historicalQueueStatus?: HistoricalQueueStatus;
}
